module.exports = __webpack_public_path__ + "img/collection-weddingRingsWhitegold.d3f76d5.jpg";